export const SET_ADVOCACY_MESSAGE_DELIVERED = "SET_ADVOCACY_MESSAGE_DELIVERED"
export const SET_LAUNCH_PROACTIVE_ADVOCACY_FLAG = "SET_LAUNCH_PROACTIVE_ADVOCACY_FLAG";


// WEBPACK FOOTER //
// ./modules/advocacy/actions/actionTypes.ts